// extracted by mini-css-extract-plugin
export default {"routineblock":"QT","container":"RT","carousel":"ST","routine":"TT","heading":"UT","routinelist":"VT","routineitem":"WT","routineimg":"XT","routinedesc":"YT","routinename":"ZT","routinetext":"aU","carouselwrap":"bU"};
    if(module.hot) {
      // 1730991509995
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  